import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import News from "src/features/news/News";
import ActivitiesContainerWrapper from "src/features/activityLog/ActivitiesContainerWrapper";
const RecentActivitySection = () => {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsxs("h6", { className: "text-uppercase text-center fw-bold mb-100", children: ["- ", t("Recent.activity_"), " -"] }), _jsx(News, {}), _jsx(ActivitiesContainerWrapper, {})] }));
};
export default RecentActivitySection;
